import { SocialPlatforms } from "../components/campaign/types";
import { DAYS_OF_WEEK } from "./daysOfWeek";

// MB-1454: extracted from CreateCampaign so the schedule math is testable and
// null-safe. Prod campaigns carried postTimes {hour:null, minute:null} (a
// validation gap, closed api-side in the same ticket); the old inline
// formatTime did pt.hour.toString() on that shape and — with no ErrorBoundary
// — blanked the entire wizard for the campaign's owner on every mount.

export interface SchedulePostTime {
    hour: number;
    minute: number;
}

interface SchedulePlatform {
    name: SocialPlatforms | string;
    frequency?: string;
    dayOfWeek?: string[];
    postTimes?: SchedulePostTime[];
}

interface ScheduleCampaign {
    platforms?: SchedulePlatform[];
}

/** "HH:MM", or null when the entry is malformed (never throws). */
export const formatTime = (
    pt: SchedulePostTime | null | undefined,
): string | null =>
    pt && Number.isInteger(pt.hour) && Number.isInteger(pt.minute)
        ? `${pt.hour.toString().padStart(2, "0")}:${pt.minute
              .toString()
              .padStart(2, "0")}`
        : null;

export const getOccupiedSlotsByPlatform = (
    settings: ScheduleCampaign[] | undefined,
): { [platform in SocialPlatforms]?: Set<string> } => {
    const mapping: { [platform in SocialPlatforms]?: Set<string> } = {};
    if (!settings) return mapping;

    settings.forEach((campaign) => {
        (campaign.platforms ?? []).forEach((platform) => {
            if (!platform || typeof platform.name !== "string") return;
            const name = platform.name as SocialPlatforms;
            if (!mapping[name]) {
                mapping[name] = new Set();
            }
            const days =
                platform.frequency === "Daily"
                    ? DAYS_OF_WEEK
                    : platform.dayOfWeek && platform.dayOfWeek.length > 0
                    ? platform.dayOfWeek
                    : [];
            (Array.isArray(platform.postTimes)
                ? platform.postTimes
                : []
            ).forEach((pt) => {
                const timeStr = formatTime(pt);
                if (timeStr === null) return; // skip poison entries
                days.forEach((day: string) => {
                    mapping[name]?.add(`${day}-${timeStr}`);
                });
            });
        });
    });
    return mapping;
};
